function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, JSON, Object, String) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['pane-base'] = function({
      updateSizeOnPostpatch
    } = {
      updateSizeOnPostpatch: true
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const postpatch = updateSizeOnPostpatch ? $helpers.updateRenderedSize : () => null;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-base': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "hook": {
              insert: $helpers.updateRenderedSizeOnNextFrame,
              postpatch,
            },
            "class": {
              'builder-pane-container': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(block && block());;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['pane-title'] = function(title, options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-title': true
          },
        }, (function() {
          var __jade_nodes = [];
          options = options || {};
          __jade_nodes = __jade_nodes.concat((options.upsell) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-upsell-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: 'lightning-bolt'
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'builder-pane-upsell-text': true
                },
              }, [__vjadeSafeCode(title)]));
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: '/pricing',
                  target: '_blank'
                }),
                "class": {
                  'builder-pane-upsell-text': true,
                  'builder-pane-upgrade-link': true
                },
              }, [__vjadeSafeCode(options.upsellLinkText)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((title) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  title
                }),
                "class": {
                  'builder-pane-title-label': true
                },
              }, [__vjadeSafeCode(title)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(block && block());
          __jade_nodes = __jade_nodes.concat((options.backButton && $helpers.numPanes() > 1) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedBackButton
              },
              "class": {
                'builder-pane-title-button': true,
                'builder-pane-back-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: 'caret-left'
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((options.closeButton) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                click: $helpers.clickedCloseButton
              },
              "class": {
                'builder-pane-title-button': true,
                'builder-pane-close-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: 'x'
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['highlight-matches'] = function(matches) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (matches);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, substr, si) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": Object.assign({}, {
                    'builder-pane-matches-search': !(si % 2)
                  }, {
                    'builder-pane-substr': true
                  }),
                }, [__vjadeSafeCode(substr)]));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var si = $$objKey;
                if ($$obj.hasOwnProperty(si)) {
                  $$iterated = true;
                  var substr = $$obj[si];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": Object.assign({}, {
                        'builder-pane-matches-search': !(si % 2)
                      }, {
                        'builder-pane-substr': true
                      }),
                    }, [__vjadeSafeCode(substr)]));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['screen-option'] = function(label, options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        options = options || {};
        __jade_nodes = __jade_nodes.concat((!options.noIcon) ? ((function() {
          var __jade_nodes = [];
          const icon = options.icon;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'builder-pane-option-icon': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon,
                empty: !icon
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-option-label': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((options.matches) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['highlight-matches'].call(this, options.matches));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-label': true
              },
            }, [__vjadeSafeCode(label)]));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat((options.description) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'builder-pane-description': true
              },
            }, [__vjadeSafeCode(options.description)]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['small-caret-icon'] = function(options) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        options = options || {};
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-caret-icon': true,
            'builder-pane-small-caret': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": __vjadeStringifyAttrsIfObj({
              icon: `caret-${options.direction || 'right'}`
            }),
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['pane-loader'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-loading': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-spinner"));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const selected = $helpers.getSelectedFrequencyOperator();
    const activeIdx = $helpers.getBuilderState().activeIdx;
    return {
      value: (h("div", {
        "class": {
          'cohorts-builder-frequency': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(jade_mixins['pane-base'].call({
          block: function() {
            return (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("ul", {
                "class": {
                  'builder-pane-screen-options-list': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = ($helpers.FREQUENCY_OPERATOR_LIST);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, frequencyOperator, idx) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("li", {
                          "on": {
                            click: () => $helpers.clickedFrequencyOperator(frequencyOperator),
                            mouseenter: () => $helpers.updateActiveIndex(idx)
                          },
                          "class": Object.assign({}, {
                            'builder-pane-list-option-active': idx === activeIdx,
                            'builder-pane-list-option-selected': frequencyOperator === selected,
                          }, {
                            'builder-pane-list-option': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(jade_mixins['screen-option'].call(this, frequencyOperator, {
                            noIcon: true
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var idx = $$objKey;
                        if ($$obj.hasOwnProperty(idx)) {
                          $$iterated = true;
                          var frequencyOperator = $$obj[idx];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("li", {
                              "on": {
                                click: () => $helpers.clickedFrequencyOperator(frequencyOperator),
                                mouseenter: () => $helpers.updateActiveIndex(idx)
                              },
                              "class": Object.assign({}, {
                                'builder-pane-list-option-active': idx === activeIdx,
                                'builder-pane-list-option-selected': frequencyOperator === selected,
                              }, {
                                'builder-pane-list-option': true
                              }),
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(jade_mixins['screen-option'].call(this, frequencyOperator, {
                                noIcon: true
                              }));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this);
          }
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;